export default {"src":"/login-app/[GIT_HASH]/_next/static/media/forum.0c3380b9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};